window.addEventListener('load', () => {
    initializeVideoBlock();
});

window.addEventListener('resize', () => {

});

function initializeVideoBlock() {
    const videoBlocks = document.querySelectorAll('.video-block');

    function isInFullscreen() {
        return !!(document.fullscreenElement || document.webkitFullscreenElement || document.msFullscreenElement);
    }

    function safeExitFullscreen() {
        if (!isInFullscreen()) return;

        const exit = document.exitFullscreen || document.webkitExitFullscreen || document.msExitFullscreen;
        try {
            const result = exit && exit.call(document);
            if (result && typeof result.then === 'function') {
                result.catch(() => {});
            }
        } catch (e) {
            console.log('Error exiting fullscreen:', e);
            // ignore errors when document isn't in fullscreen or exit fails
        }
    }

    videoBlocks.forEach((block) => {
        const playButton = block.querySelector('.video-play-button');
        const video = block.querySelector('.video-block-video');
        const embedContainer = block.querySelector('.video-embed');

        if (playButton) {
            playButton.addEventListener('click', () => {
                if (video) {
                    video.play();
                    video.muted = false;
                    playButton.classList.add('is-hidden');

                    if (video.requestFullscreen) {
                        video.requestFullscreen();
                    } else if (video.webkitRequestFullscreen) { /* Safari */
                        video.webkitRequestFullscreen();
                    } else if (video.msRequestFullscreen) { /* IE11 */
                        video.msRequestFullscreen();
                    }
                } else if (embedContainer) {
                    const youtubeId = embedContainer.dataset.youtubeId;
                    embedContainer.innerHTML = `<iframe src="https://www.youtube.com/embed/${youtubeId}?autoplay=1&rel=0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>`;
                    playButton.classList.add('is-hidden');
                    
                    // Fullscreen for iframe
                    const iframe = embedContainer.querySelector('iframe');
                    if (iframe.requestFullscreen) iframe.requestFullscreen();
                    else if (iframe.webkitRequestFullscreen) iframe.webkitRequestFullscreen();
                }
            });

            if (video) {
                video.addEventListener('ended', () => {
                    playButton.classList.remove('is-hidden');
                    safeExitFullscreen();
                });

                video.addEventListener('click', () => {
                    video.pause();
                    playButton.classList.remove('is-hidden');
                    safeExitFullscreen();
                });

                document.addEventListener('fullscreenchange', () => {
                    if (!document.fullscreenElement && video.paused) {
                        playButton.classList.remove('is-hidden');
                    }
                });

                document.addEventListener('webkitfullscreenchange', () => {
                    if (!document.webkitFullscreenElement && video.paused) {
                        playButton.classList.remove('is-hidden');
                    }
                });
            }
        }
    });
}
